import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import { URL, getToken } from "../utils";
import { customSelectStyles } from "../utils/selectStyles";
import axios from "axios";
import { toast } from "react-toastify";

const DegustationModal = ({
  isOpen,
  onClose,
  onSave,
  degustation,
  type,
  prospectId,
  prospectName,
  clientId,
  clientName,
  magasinId,
  entityType = "prospect", // "prospect" ou "client"
}) => {
  // Déterminer l'entité en fonction du type
  const entityId = entityType === "client" ? clientId : prospectId;
  const entityName = entityType === "client" ? clientName : prospectName;
  const entityLabel = entityType === "client" ? "Client" : "Prospect";

  const [formData, setFormData] = useState({
    stock_item: null,
    // quantite: "",
    note: 0,
    commentaire: "",
  });
  const [products, setProducts] = useState([]);
  const [magasins, setMagasins] = useState([]);
  const [selectedMagasinId, setSelectedMagasinId] = useState(magasinId);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingMagasinForArticle, setIsLoadingMagasinForArticle] =
    useState(false);
  const token = getToken();

  const fetchMagasins = useCallback(async () => {
    try {
      const [sPResponse, ePResponse] = await Promise.all([
        axios.get(`${URL}Magasins/magasins-list`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
        axios.get(`${URL}Magasins/liste-entrepots`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }),
      ]);

      const magasinsOptions = sPResponse.data.map((magasin) => ({
        value: magasin.id,
        label: magasin.nom,
      }));

      //Ejouter les entrepôts de la liste
      ePResponse.data.forEach((entrepot) => {
        magasinsOptions.push({
          value: entrepot.id,
          label: `${entrepot.nom} (Entrepôt)`,
        });
      });

      setMagasins(magasinsOptions);
    } catch (error) {
      console.error("Erreur lors du chargement des magasins:", error);
      toast.error("Erreur lors du chargement des magasins");
    }
  }, [token]);

  // Nouvelle fonction pour trouver le magasin qui contient un article spécifique
  const findMagasinForArticle = useCallback(
    async (stockItemId) => {
      setIsLoadingMagasinForArticle(true);
      try {
        // Récupérer directement tous les magasins et entrepôts
        const [sPResponse, ePResponse] = await Promise.all([
          axios.get(`${URL}Magasins/magasins-list`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
          axios.get(`${URL}Magasins/liste-entrepots`, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }),
        ]);

        const allMagasins = [
          ...sPResponse.data.map((m) => ({ value: m.id, label: m.nom })),
          ...ePResponse.data.map((e) => ({
            value: e.id,
            label: `${e.nom} (Entrepôt)`,
          })),
        ];

        for (const magasin of allMagasins) {
          try {
            const response = await axios.get(
              `${URL}Magasins/articles-magasin/${magasin.value}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            const foundArticle = response.data.stock_items.find(
              (article) => article.id === stockItemId,
            );

            if (foundArticle) {
              return magasin.value;
            }
          } catch (error) {
            console.error(
              `Erreur lors de la vérification du magasin ${magasin.label}:`,
              error,
            );
            // Continuer avec le magasin suivant
          }
        }

        console.warn(
          `Article ${stockItemId} introuvable dans tous les magasins`,
        );
        return null;
      } catch (error) {
        console.error(
          "Erreur lors de la recherche du magasin pour l'article:",
          error,
        );
        return null;
      } finally {
        setIsLoadingMagasinForArticle(false);
      }
    },
    [token],
  );

  const fetchProducts = useCallback(async () => {
    const currentMagasinId = selectedMagasinId || magasinId;

    if (!currentMagasinId) {
      setProducts([]);
      return;
    }

    try {
      const response = await axios.get(
        `${URL}Magasins/articles-magasin/${currentMagasinId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const productsOptions = response.data.stock_items.map((article) => ({
        value: article.id,
        label: article.nom,
        // stock: article.quantite,
        // Afficher le stock disponible dans le label
        labelWithStock: `${article.nom} (Stock: ${article.quantite})`,
      }));

      setProducts(productsOptions);
    } catch (error) {
      console.error("Erreur lors du chargement des articles:", error);
      toast.error("Erreur lors du chargement des articles");
      // Fallback with empty array if endpoint fails
      setProducts([]);
    }
  }, [token, selectedMagasinId, magasinId]);

  useEffect(() => {
    if (!isOpen) return;

    const initializeModal = async () => {
      // Charger les magasins si aucun magasin n'est défini
      if (!magasinId) {
        await fetchMagasins();
      } else {
        setSelectedMagasinId(magasinId);
      }

      if (degustation && (type === "edit" || type === "view")) {
        // Pour la modification ou la visualisation, trouver automatiquement le magasin
        let targetMagasinId = magasinId;

        // Si aucun magasin n'est fourni et qu'on a un stock_item, trouver le magasin correspondant
        if (!magasinId && degustation.stock_item) {
          targetMagasinId = await findMagasinForArticle(degustation.stock_item);
          if (targetMagasinId) {
            setSelectedMagasinId(targetMagasinId);
          }
        }

        // Charger les produits du magasin cible
        if (targetMagasinId) {
          try {
            const response = await axios.get(
              `${URL}Magasins/articles-magasin/${targetMagasinId}`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              },
            );

            const productsOptions = response.data.stock_items.map(
              (article) => ({
                value: article.id,
                label: article.nom,
                // stock: article.quantite,
                labelWithStock: `${article.nom} (Stock: ${article.quantite})`,
              }),
            );

            setProducts(productsOptions);

            // Trouver et sélectionner l'article correspondant
            const selectedProduct = productsOptions.find(
              (product) => product.value === degustation.stock_item,
            );

            setFormData({
              stock_item: selectedProduct || {
                value: degustation.stock_item,
                label: degustation.product_name,
              },
              // quantite: degustation.quantite || "",
              note: degustation.note || 0,
              commentaire: degustation.commentaire || "",
            });
          } catch (error) {
            console.error("Erreur lors du chargement des articles:", error);
            // Fallback avec les données existantes
            setFormData({
              stock_item: degustation.stock_item
                ? {
                    value: degustation.stock_item,
                    label: degustation.product_name,
                  }
                : null,
              // quantite: degustation.quantite || "",
              note: degustation.note || 0,
              commentaire: degustation.commentaire || "",
            });
          }
        } else {
          // Pas de magasin trouvé, utiliser les données de base
          setFormData({
            stock_item: degustation.stock_item
              ? {
                  value: degustation.stock_item,
                  label: degustation.product_name,
                }
              : null,
            // quantite: degustation.quantite || "",
            note: degustation.note || 0,
            commentaire: degustation.commentaire || "",
          });
        }
      } else if (type === "create") {
        // Pour la création, charger les produits du magasin par défaut
        if (magasinId) {
          await fetchProducts();
        }

        // Reset form for new degustation
        setFormData({
          stock_item: null,
          // quantite: "",
          note: 0,
          commentaire: "",
        });
      }
    };

    initializeModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, type, degustation?.id, magasinId]);

  // Recharger les produits quand le magasin sélectionné change
  useEffect(() => {
    if (selectedMagasinId && isOpen) {
      fetchProducts();
      // Reset product selection when magasin changes
      setFormData((prev) => ({ ...prev, stock_item: null }));
    }
  }, [selectedMagasinId, fetchProducts, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!magasinId && !selectedMagasinId) {
      toast.error("Veuillez sélectionner un magasin");
      return;
    }

    if (!formData.stock_item) {
      toast.error("Veuillez sélectionner un produit");
      return;
    }

    if (!entityId) {
      toast.error(`${entityLabel} non défini`);
      return;
    }

    // if (!formData.quantite || parseFloat(formData.quantite) <= 0) {
    //   toast.error("Veuillez saisir une quantité valide");
    //   return;
    // }

    // Vérification du stock
    // const quantity = parseFloat(formData.quantite);
    // if (
    //   formData.stock_item.stock !== undefined &&
    //   quantity > formData.stock_item.stock
    // ) {
    //   toast.error(
    //     `La quantité demandée (${quantity}) dépasse le stock disponible (${formData.stock_item.stock})`
    //   );
    //   return;
    // }

    setIsSubmitting(true);

    try {
      // Construire les données selon le type d'entité
      const submitData = {
        stock_item: formData.stock_item.value,
        // quantite: formData.quantite,
        note: formData.note,
        commentaire: formData.commentaire,
      };

      // Ajouter le champ approprié selon le type d'entité
      if (entityType === "client") {
        submitData.client = entityId;
        submitData.prospect = null;
      } else {
        submitData.prospect = entityId;
        submitData.client = null;
      }

      // La date de dégustation est gérée automatiquement par le backend

      console.log("Données soumises:", submitData);
      if (type === "create") {
        await axios.post(`${URL}Prospects/degustation-create`, submitData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Dégustation créée avec succès");
      } else if (type === "edit") {
        await axios.put(
          `${URL}Prospects/degustation-update/${degustation.id}`,
          submitData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          },
        );
        toast.success("Dégustation modifiée avec succès");
      }

      onSave();
    } catch (error) {
      console.error("Erreur lors de la sauvegarde:", error);
      toast.error("Erreur lors de la sauvegarde");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async () => {
    if (
      !window.confirm("Êtes-vous sûr de vouloir supprimer cette dégustation ?")
    ) {
      return;
    }

    try {
      await axios.delete(
        `${URL}Prospects/degustation-delete/${degustation.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      toast.success("Dégustation supprimée avec succès");
      onSave();
    } catch (error) {
      console.error("Erreur lors de la suppression:", error);
      toast.error("Erreur lors de la suppression");
    }
  };

  const renderStars = () => {
    return Array.from({ length: 5 }, (_, index) => (
      <button
        key={index}
        type="button"
        onClick={() =>
          type !== "view" &&
          setFormData((prev) => ({ ...prev, note: index + 1 }))
        }
        disabled={type === "view"}
        className={`w-6 h-6 ${
          index < formData.note ? "text-yellow-400" : "text-gray-300"
        } ${
          type !== "view"
            ? "hover:text-yellow-500 cursor-pointer"
            : "cursor-default"
        }`}
      >
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
        </svg>
      </button>
    ));
  };

  if (!isOpen) return null;

  const isReadOnly = type === "view";
  const title =
    type === "create"
      ? "Nouvelle dégustation"
      : type === "edit"
        ? "Modifier la dégustation"
        : "Détails de la dégustation";

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b">
          <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <CloseIcon />
          </button>
        </div>

        {/* Body */}
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Entity Display (Prospect or Client) */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              {entityLabel}
            </label>
            <div className="w-full p-3 bg-gray-50 border border-gray-200 rounded-md text-gray-800">
              <div className="flex items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3 ${
                    entityType === "client"
                      ? "bg-blue-100 text-blue-600"
                      : "bg-amber-100 text-amber-600"
                  }`}
                >
                  {entityName ? entityName.charAt(0) : entityLabel.charAt(0)}
                </div>
                <span className="font-medium">
                  {entityName || `${entityLabel} non défini`}
                </span>
              </div>
            </div>
          </div>

          {/* Magasin Selection - Only show if no magasinId is provided */}
          {!magasinId && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Magasin *
                {isLoadingMagasinForArticle && (
                  <span className="text-sm text-blue-600 ml-2">
                    (Recherche du magasin...)
                  </span>
                )}
              </label>
              <Select
                value={
                  magasins.find((m) => m.value === selectedMagasinId) || null
                }
                onChange={(selected) =>
                  setSelectedMagasinId(selected ? selected.value : null)
                }
                options={magasins}
                placeholder="Sélectionner un magasin"
                isSearchable
                isDisabled={isReadOnly || isLoadingMagasinForArticle}
                className="text-sm"
                styles={customSelectStyles}
                noOptionsMessage={() => "Aucun magasin disponible"}
              />
              {!selectedMagasinId && !isLoadingMagasinForArticle && (
                <p className="text-sm text-amber-600 mt-1">
                  Veuillez sélectionner un magasin pour voir les produits
                  disponibles
                </p>
              )}
            </div>
          )}

          {/* Product Selection */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Produit *{" "}
              {formData.stock_item &&
                formData.stock_item.stock !== undefined && (
                  <span className="text-sm text-gray-500">
                    (Stock disponible: {formData.stock_item.stock})
                  </span>
                )}
            </label>
            <Select
              value={formData.stock_item}
              onChange={(selected) =>
                setFormData((prev) => ({ ...prev, stock_item: selected }))
              }
              options={products}
              getOptionLabel={(option) =>
                `${option.label} (Stock: ${option.stock})`
              }
              placeholder="Sélectionner un produit"
              isSearchable
              isDisabled={isReadOnly || (!magasinId && !selectedMagasinId)}
              className="text-sm"
              styles={customSelectStyles}
              noOptionsMessage={() => {
                if (!magasinId && !selectedMagasinId) {
                  return "Veuillez d'abord sélectionner un magasin";
                }
                return "Aucun article disponible dans ce magasin";
              }}
            />
          </div>

          {/* Quantity */}
          {/* <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Quantité{" "}
              {formData.stock_item &&
                formData.stock_item.stock !== undefined && (
                  <span className="text-sm text-gray-500">
                    (Max: {formData.stock_item.stock})
                  </span>
                )}
            </label>
            <input
              type="number"
              step="0.01"
              min="0.01"
              max={formData.stock_item ? formData.stock_item.stock : undefined}
              value={formData.quantite}
              onChange={(e) => {
                const value = parseFloat(e.target.value);
                const maxStock = formData.stock_item
                  ? formData.stock_item.stock
                  : null;

                if (maxStock && value > maxStock) {
                  toast.warning(
                    `La quantité ne peut pas dépasser le stock disponible (${maxStock})`
                  );
                  return;
                }

                setFormData((prev) => ({ ...prev, quantite: e.target.value }));
              }}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
              placeholder="Ex: 0.5"
              readOnly={isReadOnly}
            />
          </div> */}

          {/* Rating */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Note ({formData.note}/5)
            </label>
            <div className="flex gap-1">{renderStars()}</div>
          </div>

          {/* Date gérée côté backend, pas de champ UI */}

          {/* Comment */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Commentaire
            </label>
            <textarea
              value={formData.commentaire}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  commentaire: e.target.value,
                }))
              }
              rows={4}
              className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-amber-500 focus:border-amber-500"
              placeholder="Votre appréciation de la dégustation..."
              readOnly={isReadOnly}
            />
          </div>

          {/* Footer */}
          <div className="flex justify-between pt-4 border-t">
            <div>
              {type === "view" && degustation && (
                <button
                  type="button"
                  onClick={handleDelete}
                  className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:ring-2 focus:ring-red-500"
                >
                  Supprimer
                </button>
              )}
            </div>

            <div className="flex gap-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
              >
                {isReadOnly ? "Fermer" : "Annuler"}
              </button>

              {!isReadOnly && (
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-4 py-2 bg-amber-600 text-white rounded-md hover:bg-amber-700 focus:ring-2 focus:ring-amber-500 disabled:opacity-50"
                >
                  {isSubmitting ? "Enregistrement..." : "Enregistrer"}
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

const CloseIcon = () => (
  <svg
    className="w-6 h-6"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export default DegustationModal;
